import React from "react"
import { cn } from "../../lib/utils"

export const PulsatingButton = React.forwardRef(function PulsatingButton(
  { variant = "pulse", className, children, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn("relative isolate inline-flex overflow-hidden rounded-2xl", className)} {...props}>
      {variant === "ripple" && <><span className="pointer-events-none absolute inset-1 rounded-[inherit] border border-current/35 animate-ping [animation-duration:2.2s]" /><span className="pointer-events-none absolute inset-0 rounded-[inherit] bg-current/10 animate-pulse" /></>}
      <div className="relative z-10">{children}</div>
    </div>
  )
})
